import React, { createContext, useState, ReactNode, useMemo } from "react";

interface ProfileContextProps {
  profile: any;
  setProfile: React.Dispatch<React.SetStateAction<any>>;
  history: any[];
  setHistory: React.Dispatch<React.SetStateAction<any[]>>;
  loggedIn: boolean;
  setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
  leaderBoard: string;
  setLeaderBoard: React.Dispatch<React.SetStateAction<string>>;
  otherUserPerformance: string;
  setOtherUserPerformance: React.Dispatch<React.SetStateAction<string>>;
}

export const ProfileContext = createContext<ProfileContextProps>(
  {} as ProfileContextProps
);

interface APIProviderProps {
  children: ReactNode;
}

const APIProvider: React.FC<APIProviderProps> = ({ children }) => {
  const [profile, setProfile] = useState<any>(null);
  const [history, setHistory] = useState<any[]>([]);
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const [leaderBoard, setLeaderBoard] = useState<string>("");
  const [otherUserPerformance, setOtherUserPerformance] = useState<string>("");

  const contextValue = useMemo(
    () => ({
      profile,
      setProfile,
      history,
      setHistory,
      loggedIn,
      setLoggedIn,
      leaderBoard,
      setLeaderBoard,
      otherUserPerformance,
      setOtherUserPerformance,
    }),
    [profile, history, loggedIn, leaderBoard, otherUserPerformance]
  );

  return (
    <ProfileContext.Provider value={contextValue}>
      {children}
    </ProfileContext.Provider>
  );
};

export { APIProvider };
